import React from 'react';
const Pipe90Curve4Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="50.1162" y1="90.2344" x2="110.6025" y2="90.2344" gradientTransform="matrix(1 0 0 -1 2.0576 137.9668)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <linearGradient id={`${id}_2`} gradientUnits="userSpaceOnUse" x1="39.0601" y1="25.2178" x2="39.0601" y2="80.4253" gradientTransform="matrix(1 0 0 -1 2.0576 137.9668)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
        <radialGradient id={`${id}_3`} cx="144.7432" cy="318.8779" r="23.7788" gradientTransform="matrix(2.9866 -0.2001 -0.2179 -2.719 -317.7034 947.3754)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#585858" />
          <stop offset="0.1" stopColor="#656565" />
          <stop offset="0.22" stopColor="#878787" />
          <stop offset="0.4" stopColor="#BDBDBD" />
          <stop offset="0.53" stopColor="#DFDFDF" />
          <stop offset="0.64" stopColor="#C2C2C2" />
          <stop offset="0.89" stopColor="#777777" />
          <stop offset="1" stopColor="#535353" />
        </radialGradient>
        <linearGradient id={`${id}_4`} gradientUnits="userSpaceOnUse" x1="50.1162" y1="113.1973" x2="110.6025" y2="113.1973" gradientTransform="matrix(1 0 0 -1 2.0576 137.9668)">
          <stop offset="0.01" stopColor="#666666" />
          <stop offset="0.18" stopColor="#929292" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="0.74" stopColor="#A8A8A8" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <linearGradient id={`${id}_5`} gradientUnits="userSpaceOnUse" x1="18.8184" y1="25.2744" x2="18.8184" y2="80.4819" gradientTransform="matrix(1 0 0 -1 2.0576 137.9668)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="0.75" stopColor="#A2A2A2" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
      </defs>
      <rect x="52.174" y="44.986" fill={`url(#${id}_1)`} width="60.486" height="5.491" />
      <rect x="38.983" y="57.542" fill={`url(#${id}_2)`} width="4.269" height="55.207" />
      <path fill={`url(#${id}_3)`} d="M41.341,112.749c34.771,0,71.319-21.826,71.319-65.055l-60.45-0.162c-1.263,7.605-4.71,9.44-10.676,9.932C40.833,71.956,41.341,112.749,41.341,112.749z" />
      <rect x="52.174" fill={`url(#${id}_4)`} width="60.486" height="49.54" />
      <rect y="57.485" fill={`url(#${id}_5)`} width="41.752" height="55.207" />
    </svg>
  );
};
export default Pipe90Curve4Icon;
